<template>
  <!-- 认证弹窗certification -->
  <div class="certification">
    <el-dialog
      title="职业认证"
      width="366px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <img src="../../assets/img/盾牌保险认证.png" alt="" />
      <el-form ref="form" :model="form" :rules="rules">
        <!-- 单位名称 -->
        <el-form-item prop="CompanyName">
          <el-input
            v-model="form.CompanyName"
            placeholder="请输入单位名称"
          ></el-input>
        </el-form-item>

        <!-- 职位名称 -->
        <el-form-item prop="PostsName">
          <el-input
            v-model="form.PostsName"
            placeholder="请输入职位"
          ></el-input>
        </el-form-item>

        <!-- 选择区域 -->
        <el-form-item prop="RegionCode">
          <el-cascader
            placeholder="请选择区域"
            :options="options"
            v-model="form.RegionCode"
            @change="handleChange"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// 引入地区信息
import text from "../../../static/districts.json";

export default {
  name: "certification",
  props: {
    certificationInfo: {
      // 表格数据
      type: Object,
      default: function() {
        return {};
      }
    },
    userData: {
      type: Object
    }
  },
  data() {
    return {
      // 表单数据
      form: {
        CompanyName: "",
        PostsName: "",
        Area: "",
        Region: "", //选择器选择的省市区
        RegionCode: ""
      },
      // 表单验证rules
      rules: {
        CompanyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["change", "blur"]
          }
        ],
        PostsName: [
          {
            required: true,
            message: "请输入职位名称",
            trigger: ["change", "blur"]
          }
        ],
        RegionCode: [
          {
            required: true,
            message: "请选择区域",
            trigger: ["change", "blur"]
          }
        ]
      },
      options: [],
      cityArr: [], //城市列表
      // areaArr: [], //区县列表
      province: "", //省
      city: "", //市
      area: "", // 区县,
      provinceCityArea: "" //选择器选择的省市区
    };
  },
  computed: {
    dialogVisible: {
      get() {
        this.Initialize();
        return this.certificationInfo.dialogVisible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    }
    // userData: {
    //   get() {
    //     return this.$store.state.users.userData;
    //   }
    // }
  },
  methods: {
    // 初始化数据
    Initialize() {
      if (this.userData) {
        // console.log(this.userData, "用户认证的信息");
        // // console.log(text);
        this.form.CompanyName = this.userData.CompanyName;
        this.form.PostsName = this.userData.PostsName;
        // this.$nextTick(() => {
        this.form.RegionCode = this.userData.RegionCode;
        // });
      }
    },
    // 获取地区信息
    initDistPicker() {
      let self = this;
      let distData = text;
      let options = [];
      // 省
      for (var provinceKy in distData["100000"]) {
        let optProvinceItem = {
          value: provinceKy,
          label: distData["100000"][provinceKy]
        };
        if (distData[provinceKy]) {
          // 市
          for (var cityKy in distData[provinceKy]) {
            optProvinceItem.children = optProvinceItem.children
              ? optProvinceItem.children
              : [];
            let optCityItem = {
              value: cityKy,
              label: distData[provinceKy][cityKy]
            };
            if (distData[cityKy]) {
              // 区
              // for (var areaKy in distData[cityKy]) {
              //   optCityItem.children = optCityItem.children
              //     ? optCityItem.children
              //     : [];
              //   let optAreaItem = {
              //     value: areaKy,
              //     label: distData[cityKy][areaKy]
              //   };
              //   optCityItem.children.push(optAreaItem);
              // }
            }
            optProvinceItem.children.push(optCityItem);
          }
        }
        options.push(optProvinceItem);
      }
      self.distData = distData;
      self.options = options;
      // });
    },
    handleChange(value) {
      let self = this;
      console.log("value=>", value);
      this.form.RegionCode = value;
      //获取省名
      self.options.map((item, index) => {
        if (item.value == value[0]) {
          self.cityArr = item.children; //存储城市列表
          self.province = item.label;
        }
      });
      //获取市名
      self.cityArr.map((item, index) => {
        if (item.value == value[1]) {
          self.areaArr = item.children; //存储区县列表
          self.city = item.label;
        }
      });
      //获取区县名
      // self.areaArr.map((item, index) => {
      //   if (item.value == value[2]) {
      //     self.area = item.label;
      //   }
      // });
      self.form.Region = self.province + self.city + self.area;
      console.log(this.form);
    },
    handleClose() {
      this.$emit("update:visible", false);
    },
    // 提交认证操作
    submitForm() {
      console.log(this.form, "返回的数据");
      try {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.$emit("UserAuthentication", this.form);
            this.dialogVisible = false;
            this.$refs["form"].resetFields();
            File = true;
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  },
  created() {
    // 调用获取地区数据
    this.initDistPicker();
  }
};
</script>

<style lang="less" scoped>
/deep/.el-dialog__header {
  border-bottom: none !important;
}

/deep/ .el-form-item__error {
  margin-left: 35px;
}

/deep/.el-dialog__header {
  padding: 65px 20px 10px;
}
/deep/.el-dialog {
  width: 366px;
  height: 460px;
  background: #ffffff;
  border-radius: 10px;
}
.certification {
  position: relative;
  // background: url(../../assets/img/盾牌保险认证.png) no-repeat;
  // background-size: 20px 20px;
  // top: 0px;
  img {
    position: absolute;
    top: 68px;
    left: 125px;
  }
}
.certification /deep/.el-input__inner {
  // margin-bottom: 29px;
  background-color: #fff;
  border: none;
  border-radius: 1px;
  width: 266px;
  /* border: 1px solid #dcdfe6; */
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ebebeb;
}
.el-button--primary {
  width: 266px;
  height: 40px;
  background: #5b90f0;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  text-align: center;
}
/deep/.el-form-item__content {
  // margin: 50px 0px 72px !important;
  margin: auto;
}
.el-input__prefix,
.el-input__suffix {
  height: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/certification.vue